export default "__VITE_ASSET__86aee84e__"